import { Notifications } from '@types';
import memoize from 'fast-memoize';
import { UIConstants } from '@constants';

const formatNotification = (alertContent: string, templateType: string): Notifications => {
    return {
        notificationId: '',
        subject: '',
        content: alertContent,
        link: '#',
        template: { templateIcon: templateType },
        loanType: ''
    };
};

export const filterAlertsBystatus = memoize((accountStatus: string, accountStatusNameKey: string) => {
    const notification = UIConstants.notificationByStatus.find(item => {
        if (
            accountStatusNameKey &&
            (accountStatusNameKey === UIConstants.ActiveLossMitigationForeclosureHold ||
                accountStatusNameKey === UIConstants.statusLossMitigationRepaymentPlan)
        ) {
            return item.statusKey === accountStatusNameKey;
        }
        return item.status === accountStatus;
    });
    if (notification?.status) {
        return formatNotification(notification.content, notification.type);
    }
});
